/**
 * 获取首页轮播图展示列表
 */
export const getAdvertiseList = '/integral/advertise/list';
/**
 * 获取首页分页查询积分商品集合
 */
export const getProductList = '/integral/product/list';
/**
 * 个人中心根据礼包商品 ID 获取礼包信息
 */
export const getProduct = '/integral/product/get';
/**
 * 获取用户积分收支明细
 */
export const getIncomeDetail = '/integral/getIncomeDetail';
/**
 * 个人中心根据用户 UID 获取用户积分余额
 */
export const getUserBalance = '/integral/getUserBalance';
/**
 * 个人中心用户购买积分礼包接口
 */
export const pay = '/integral/pay';
/**
 * 获取礼包购买记录
 */
export const getPurchaseHi = '/integral/purchase/history';